import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OperationalStatusHistoryEntity } from './operational-status-history.entity';

@Entity('_operational_status')
export class OperationalStatusEntity extends BaseEntity {
	@Column('varchar', { name: '_label', length: 255 })
	public label!: string;

	@Column('varchar', { name: '_status', length: 20 })
	public status!: string;

	@Column('text', { name: '_message' })
	public message!: string;

	@Column('int', { name: '_maxDownTime', nullable: true, unsigned: true })
	public maxDownTime!: number | null;

	@Column('int', {
		name: '_downAlertDebounceTime',
		nullable: true,
		unsigned: true,
	})
	public downAlertDebounceTime!: number | null;

	@Column('datetime', { name: '_lastDownAlertTime', nullable: true })
	public lastDownAlertTime!: Date | null;

	@OneToMany(
		() => OperationalStatusHistoryEntity,
		(operationalStatusHistory) => operationalStatusHistory.fkOperationalStatus,
		{},
	)
	public operationalStatusHistories!: Array<OperationalStatusHistoryEntity>;
}
